/** The training goal shared by the Plan, Progress, Now, and Settings pages. */
export const GOAL = {
  title: 'Sub-3:45 marathon',
  event: 'Twin Cities Marathon',
  date: 'Oct 11, 2026',
  targetPace: '8:34 / mi',
  currentEstimate: '3:49–3:57',
  confidence: 'Moderate',
  weeksRemaining: 15,
  phase: 'Volume building',
} as const;
